import { render, staticRenderFns } from "./voteInput.vue?vue&type=template&id=5663f86e&scoped=true"
import script from "./voteInput.vue?vue&type=script&lang=js"
export * from "./voteInput.vue?vue&type=script&lang=js"
import style0 from "./voteInput.vue?vue&type=style&index=0&id=5663f86e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5663f86e",
  null
  
)

export default component.exports